import { cx } from '@/lib/cx';
import { formatarDocumento } from '@/lib/formato';

/** CNPJ (inclusive alfanumérico) ou CPF formatado em fonte de dados. */
export function DocumentoTexto({
  valor,
  className,
}: {
  valor: string | null | undefined;
  className?: string;
}) {
  return (
    <span className={cx('font-mono text-sm tabular whitespace-nowrap', className)}>
      {formatarDocumento(valor)}
    </span>
  );
}
